import { render } from "./TheFooter.vue?vue&type=template&id=646b49e7&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=646b49e7&scoped=true&lang=css"

import exportComponent from "F:\\PROJECTS\\2022\\shop2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-646b49e7"]])

export default __exports__